// This file is auto-generated from the /filesystem directory
// Do not edit directly, instead modify files in the filesystem directory
// and run the update-filesystem.js script

const fileSystemData = {
  "type": "directory",
  "name": "filesystem",
  "children": {
    "etc": {
      "type": "directory",
      "name": "etc",
      "children": {
        "hosts": {
          "type": "file",
          "name": "hosts",
          "content": "127.0.0.1       localhost\n::1             localhost\n"
        },
        "passwd": {
          "type": "file",
          "name": "passwd",
          "content": "root:x:0:0:root:/root:/bin/bash\nuser:x:1000:1000:User,,,:/home/user:/bin/bash"
        }
      },
      "parent": null
    },
    "home": {
      "type": "directory",
      "name": "home",
      "children": {
        "user": {
          "type": "directory",
          "name": "user",
          "children": {
            "README.md": {
              "type": "file",
              "name": "README.md",
              "content": "# Web Terminal 👋\n\nA browser-based terminal playground. Type commands, explore a fake filesystem, have fun!\n\n## What's this?\n\nA terminal emulator that runs in your browser - play with Linux-style commands without breaking anything.\n\n## Features:\n\n- Command history\n- Tab completion\n- Shortcuts: Ctrl+C, Ctrl+L\n- Virtual filesystem to explore\n- Commands:\n    - `help` - Show commands\n    - `clear` - Clear screen\n    - `history` - Show past commands\n    - `neofetch` - Show system info\n    - `pwd` - Show current location\n    - `cd` - Change directory\n    - `ls` - List files\n    - `cat` - Read files\n\n## Quick Start\n\nType `neofetch` to see some info, then `ls` to look around. Hit Tab to autocomplete ur commands. Nothing breaks, so just have fun! 🎮"
            },
            "documents": {
              "type": "directory",
              "name": "documents",
              "children": {},
              "parent": null
            }
          },
          "parent": null
        }
      },
      "parent": null
    },
    "usr": {
      "type": "directory",
      "name": "usr",
      "children": {
        "bin": {
          "type": "directory",
          "name": "bin",
          "children": {},
          "parent": null
        },
        "share": {
          "type": "directory",
          "name": "share",
          "children": {
            "doc": {
              "type": "directory",
              "name": "doc",
              "children": {},
              "parent": null
            }
          },
          "parent": null
        }
      },
      "parent": null
    },
    "var": {
      "type": "directory",
      "name": "var",
      "children": {
        "log": {
          "type": "directory",
          "name": "log",
          "children": {
            "syslog": {
              "type": "file",
              "name": "syslog",
              "content": "[2025-04-10 08:15:32] System started\n[2025-04-10 08:15:34] Services initialized\n[2025-04-10 08:16:01] User login successful"
            }
          },
          "parent": null
        }
      },
      "parent": null
    }
  },
  "parent": null
};

// Build parent references
const buildParentReferences = (node) => {
  if (node.type === 'directory' && node.children) {
    for (const [name, child] of Object.entries(node.children)) {
      child.parent = node;
      if (child.type === 'directory') {
        buildParentReferences(child);
      }
    }
  }
  return node;
};

// Call this function to set up the parent references
const preparedFileSystem = buildParentReferences(fileSystemData);

export default preparedFileSystem;